import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col, Form, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import { consts, Translate, components, utils, Actions as actions, Form as CoreForm } from 'unity-core'
const { Routes } = consts
const { getEnv } = utils
const { AlertPanel, Loader, NavLink } = components
const { FormGroupWrapper, ModalWrapper } = CoreForm
import { bindActionCreators } from 'redux'
import Forgot from 'components/Forgot'
import DOMPurify from 'dompurify'
import { push } from 'react-router-redux'

const propTypes = {
  redirectRoute: PropTypes.string,
  isAuthenticating: PropTypes.bool,
  err: PropTypes.object,
  notice: PropTypes.object,
  strings: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  clearErr: PropTypes.func.isRequired,
  // getAppNotice: PropTypes.func.isRequired
  changeRoute: PropTypes.func.isRequired
}
const defaultProps = {
  isAuthenticating: false,
  redirectRoute: `/${Routes.HOME}`,
  err: null,
  notice: {}
}

export class SSOAuth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
    const { accessCode, redirectRoute, isAuthenticated, isAuthenticating } = this.props;
    this.props.clearErr();
    if (accessCode && !isAuthenticating && !isAuthenticated) {
      this.props.login("accesscode", accessCode, redirectRoute);
    }
  }


  componentDidUpdate(prevProps) {
    const { changeRoute, redirectRoute } = this.props

    if (!this.props.isAuthenticating) {
      if (!this.props.isAuthenticated) {
        changeRoute(`/login${redirectRoute ? `?redirect=${redirectRoute}`: `` }`);
      }
    }
  }

  render() {
    const { err, strings, notice } = this.props
    return (
      <div className="login-container">
        <Grid fluid className="slide-top-100">
          <Row>
            <Col>
              <Loader loaded={!this.props.isAuthenticating} />
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

SSOAuth.propTypes = propTypes
SSOAuth.defaultProps = defaultProps

const mapStateToProps = (state, ownProps) => ({
  redirectRoute: ownProps.location.query.redirect,
  accessCode: ownProps.location.query.accesscode,
  isAuthenticating: state.user.isAuthenticating,
  isAuthenticated: state.user.isAuthenticated,
  notice: state.app.notice,
  lang: state.user.lang,
  err: state.user.err
});
const mapDispatchToProps = (dispatch) => ({
  login: bindActionCreators(actions.User.login, dispatch),
  clearErr: bindActionCreators(actions.User.clearErr, dispatch),
  changeRoute: route => dispatch(push(route))
})

const decorators = _.flow([
  connect(mapStateToProps, mapDispatchToProps),
  Translate('Login', 'ForgotPassword')
]);

export default decorators(SSOAuth)
